<template>
  <h1 class="new-detail-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-if="$store.state.locale!=='uk'" @click.native="handleClick">
        <nuxt-link v-if="$store.state.locale!=='us'" :to="categoryPath">
          {{ categoryName }}
        </nuxt-link>
        <nuxt-link v-else to="">
          {{ categoryName }}
        </nuxt-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <nuxt-link v-if="secondCategoryPath" :to="secondCategoryPath">
          {{ secondCategoryName }}
        </nuxt-link>
        <template v-else>
          {{ secondCategoryName }}
        </template>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </h1>
</template>
<script>
export default {
  props: {
    categoryName: {
      type: String,
      default: '',
    },
    categoryPath: {
      type: String,
      default: '',
    },
    secondCategoryName: {
      type: String,
      default: '',
    },
    secondCategoryPath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    isBM: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.$store.state.locale === 'us') {
        return
      }

      if (this.isBM) {
        this.$router.push('/courses/list-bm');
      } else {
        this.$router.push('/courses/list');
      }
    },
  },
}
</script>
<style lang="scss">
.new-detail-breadcrumb {
  .el-breadcrumb__inner {
    a {
      font-weight: 500;
      font-size: 14px;
      color: #606266;
    }
  }

  .el-breadcrumb__inner:hover {
    a {
      color: var(--txt-color-link);
    }
  }
}

</style>
